<template>
<div class="notification-container" :style="showPanel? 'z-index: -1;' : undefined">
    <div :class="{'panel-hidden':showPanel, 'panel_container':!showPanel}"  >
        <div class="titles-container">
            <h5 @click="negotiationsActive" :class="{inactive:!showNegotiation,left:!showNegotiation}" >Negotiations</h5>
            <h5 @click="chatActive" :class="{inactive:!showChat,right:!showChat}" >Messages</h5>
        </div>
        <div class="sides-container">

            <div class="negotiations-messages-container" v-if="showNegotiation" >
               <div v-for="offer in counterOffers"  class="negotiation-container">
    
                    <div v-for="(user,key) in offer.counter_offers" class="single-offer-container">
                        <div>
                            <b><p><i class="fas fa-circle offer" v-if="user.seller.online">
                                </i> {{user.seller.name}}</p></b> 
                            <p id="fuel-type">
                                {{offer.fuel_id | fueltype}}
                            </p>       
                        </div>
                        <div class="prices-container">
                            <div>
                                <p><b>£{{user.ppl}}p/l.</b></p>
                                <p id="fuel-quantity">{{user.quantity | volumeformat}} l</p>
                            </div>
                            <span>
                                <i class="fas fa-check-circle"></i> 
                                <i class="fas fa-caret-right" @click="openSingleNegotiation(key)"></i>
                            </span>
                        </div>     
                </div>  
             </div>
            </div>
            <div class="chat-messages-container" v-if="showChat">
                <div v-for="(message,key) in chatMessages" class="user-container" @click="openMessages(key)">
                    <img :src="`assets/${message.img}.jpg`" alt="user image" class="profile-image">
                    <i class="fas fa-circle"></i>
                    <span class="msg-details"><b>{{message.firstName}}</b>
                       <p v-if="message.conversation.length>0">{{message.conversation[message.conversation.length-1].me}}</p> 
                    </span>
                </div>
            </div>
        </div>
        <div class="btn-container">
             <button class="btn show-msg" @click="redirectToMessages"> See All Negotiations</button>
        </div>
    </div>
    
</div>
   
</template>

<script>
import { mapState,mapActions,mapMutations } from 'vuex';
export default {
    data:function(){
        return{
            chatMessages:'',
            counterOffers:'',
            showChat:true,
            showNegotiation:false,
            lastMessage:''
        }
    },
    computed:{
        ...mapState('notifications',['showPanel']),
       ...mapState('negotiation',['negotiationSelected'])
    },
    methods:{
       ...mapActions('notifications',['togglePanel']),
       ...mapActions('negotiation',['selectNegotiation']),
       ...mapActions('conversation',['selectConversation','loadConversation']),
        chatActive(){
            this.showChat=true;
            this.showNegotiation=false;
        },
        negotiationsActive(){
            this.showNegotiation=true;
            this.showChat=false;
        },
        redirectToMessages(){
            this.togglePanel()
        },
        openSingleNegotiation(negotiationKey){
      
            this.togglePanel()
        },
        openMessages:async function(key){
            this.togglePanel()
            this.selectConversation(key)
            const conversationKey=key
            const conversationSelected= await this.axios.post('/api/loadConversation',{conversationKey})
            this.loadConversation(conversationSelected.data)
        }
    },
    
    created: async function(){
        const chatMessages = await this.axios('/api/getAllMessages')
        this.chatMessages= chatMessages.data.chatMessages
        this.lastMessage= this.chatMessages[this.chatMessages.length-1]
        const negotiations = await this.axios.get('/api/negotiations');

        let dataToBuild = []
        negotiations.data.forEach(negotiation=>{
            let obj={}
            obj.fuel_id=negotiation.fuel_id
            obj.counter_offers=negotiation.counter_offers
            obj.offer_id=negotiation.id
            dataToBuild.push(obj)
        })
        this.counterOffers=dataToBuild.slice(0,2)
    }   
}
</script>

<style lang="scss" scoped>
   
   .notification-container{
       
        position:relative;
    }
    
    .titles-container{
        width:100%;
     
        h5{
            width:50%;
        }
    }
    .panel-hidden{
        
        transform: translateY(500px);
        transition:all .8s ease-in-out;
    }
    .panel_container{
        transform: translateY(10px);
        transition:all .8s ease-in-out;
        min-height: 29rem;
        background-color:white;
        border-radius:.8rem;
        box-shadow: 5px 6px 25px #aca9a9;
    } 
    
    .profile-image{
        width: 2.8rem;
        height: 3rem;
        border-radius: 0.5rem;
        margin-right: 1.1rem;
        margin-left:.2rem;
    }
    .chat-messages-container{
        width:100%;
        margin-top:1rem;
    }  
   
    .titles-container{
        display: flex;
        cursor:pointer;
    }
    .sides-container{
        display: flex;
    }
    .negotiations-messages-container{
        margin-top:1rem;
        width:100%;
       
    }
    .user-container{
        cursor: pointer;
        margin-bottom:1rem;
        width:85%;
        display: flex;
        align-items:center;
        margin-left:.8rem;

        &:hover{
            background-color:map-get($theme-colors, olf-light-grey);
        }
    }
    .negotiation-container{
        margin-left:.8rem;
        cursor: pointer;
        margin-bottom:1rem;
    }
    .msg-details{
        display: flex;
        flex-direction:column;
        margin-left:1rem;
        p{  
            white-space:nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width:10rem;
        }
    }
    .inactive{
        background-color:map-get($theme-colors, olf-light-grey);
        
        &.left{
           border-top-left-radius:.8rem; 
        }
        &.right{
            border-top-right-radius:.8rem;
        }
    }
    .fa-circle{
        font-size:.4rem;
        color:map-get($theme-colors, primary);

        &.counter{
            margin-bottom:4rem;
        }
    }
    .single-offer-container{
  
        #fuel-type{
            margin-top:-.2rem;
        }
        margin-bottom:1.2rem;
        display: flex;
        justify-content:space-between;
        position:relative;
        &::after{
            position:absolute;
            content:'';
            transform:translatex(-25px);
            left:5%;
            border-bottom:solid map-get($theme-colors, olf-silversand) 1px;
            width:100%;
            bottom:-.4rem;
        }
        
    }
    #fuel-quantity{
        margin-top:-.8rem;
    }
    .prices-container{
        margin-right: 1.4rem;
        display: flex;
        width:45%;
        
    }
    .fa-check-circle{
        font-size:1.8rem;
        color:map-get($theme-colors, primary);
        margin-left:.7rem;
        margin-top:.3rem;
        align-self: center;
    }
    
    .fa-caret-right{
        margin-left:10px;
    }

    .show-msg{
        background-color:black;
        color:white;
        margin:auto;
        margin-bottom:1rem;
        height: 2rem;;
    }

    .btn-container{
        display: flex;
        margin-bottom:1rem;
    }
    
    
</style>
